import { serviceAxiosInstance } from '../config/api.service.config';

export const getCall = async (url) => {
  try {
    return await serviceAxiosInstance.get(process.env.REACT_APP_SERVICE_BASE_URL + url);
  } catch (err) {
    return err;
  }
};

export const postCall = async (url, data) => {
  try {
    return await serviceAxiosInstance.post(process.env.REACT_APP_SERVICE_BASE_URL + url, data);
  } catch (error) {
    console.error(error);
    return error;
  }
};
export const putCall = async (url, data) => {
  try {
    return await serviceAxiosInstance.put(process.env.REACT_APP_SERVICE_BASE_URL + url, data);
  } catch (error) {
    console.error(error.message);
    return error;
  }
};

export const deleteCall = async (url) => {
  try {
    return await serviceAxiosInstance.delete(process.env.REACT_APP_SERVICE_BASE_URL + url);
  } catch (error) {
    console.error(error);
    return error;
  }
};
